import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useThemePerformanceReturn } from '../hooks/useThemePerformanceReturn';
import styles from './OneDayReturnPill.module.scss';

export const OneDayReturnPill = ({ themeId }: { themeId: string }) => {
  const { t } = useTranslation('widget');

  const { value: revampValue, isNegative: revampIsNegative } =
    useThemePerformanceReturn({
      themeId,
      selectedHorizon: '1D',
    });

  const dataToUse = {
    value: revampValue,
    isNegative: revampIsNegative,
  };

  return (
    <div
      className={clsx(styles.rightHeaderWrapper, {
        [styles.negative]: dataToUse.isNegative,
      })}
    >
      <span
        className={clsx(styles.rightHeaderReturnValue, {
          [styles.negative]: dataToUse.isNegative,
        })}
      >
        {dataToUse.value}
      </span>
      <span className={styles.rightHeaderReturnLabel}>
        {t('widget:themeOverview.lastClose')}
      </span>
    </div>
  );
};
